import { ROUTER } from '@core/constants/router.constants';
import ChangemanLayout from '@modules/changeman/changeman.layout';
import MainChangemanPage from '@modules/changeman/pages/text-content';
import { PrivateRoute } from '@router/private-route';
import { RouteObject } from 'react-router-dom';

export const changemanRouter: RouteObject = {
  path: ROUTER.CHANGEMAN.INDEX,
  Component: ChangemanLayout,
  children: [{ index: true, element: <PrivateRoute element={<MainChangemanPage />} /> }],
};
